<template>
  <div class="w-100 h-100 image-upload">
    <div class="d-flex w-100 h-100 justify-content-center align-items-center" v-if="step === 1">
      <div class="card" style="width: 20rem;">
        <div class="card-body">
          <b-navbar-nav
            class="ml-auto"
            style="display:inline-block;position:absolute;top:5px;right:10px"
          >
            <LanguageDropdown />
          </b-navbar-nav>
          <h5 class="card-title text-center">{{$t("Upload Image")}}</h5>
          <p class="card-text text-center">{{$t("Take a photo or upload an image.")}}</p>
          <div class="d-flex flex-row justify-content-between">
            <button class="btn btn-primary" @click="switchTo(3)">
              <i class="flaticon-photo-camera" />
              {{$t("Camera")}}
            </button>
            <button class="btn btn-primary" @click="switchTo(2)">
              <i class="flaticon-upload" />
              {{$t("Upload")}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex w-100 h-100 justify-content-center align-items-center" v-if="step === 2">
      <div class="card">
        <div class="card-body" ref="body">
          <b-navbar-nav
            class="ml-auto"
            style="display:inline-block;position:absolute;top:5px;right:10px"
          >
            <LanguageDropdown />
          </b-navbar-nav>
          <h5 class="card-title text-center">{{$t("Upload Image")}}</h5>
          <p class="card-text text-center">{{$t("Browse for or drag and drop an image here.")}}</p>
          <form enctype="multipart/form-data" novalidate>
            <div class="custom-file">
              <input
                type="file"
                :name="uploadFieldName"
                :disabled="isSaving"
                @change="filesChange($event)"
                acceptT="image/*"
                class="custom-file-input"
                id="inputGroupFile01"
                aria-describedby="inputGroupFileAddon01"
              />
              <label class="custom-file-label" for="inputGroupFile01">Choose file</label>
            </div>
          </form>
          <div v-if="formFileList.length" class="my-4">
            <div v-for="(item, index) in formFileList" :key="index" style="font-size:1rem">
              <i class="flaticon-file-2"></i>
              {{item.name}} ({{item.size}})
            </div>
          </div>
          <p v-if="errMsg !=''" class="has-text-danger" style="margin: 1rem 0">{{ errMsg }}</p>
          <div class="mt-2 text-center">
            <button class="btn btn-secondary mr-2" @click.stop.prevent="back()">
              <i class="flaticon-reply" />
              {{$t("Back")}}
            </button>
            <button class="btn btn-primary" @click.stop.prevent="uploadImages()">
              <i class="flaticon-upload" />
              {{$t("Upload")}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="d-flex w-100 h-100 justify-content-center align-items-center camera"
      v-if="step === 3"
    >
      <video
        ref="video"
        id="video"
        v-if="hasCamera"
        autoplay
        playsinline
        class="w-100 h-100"
        style="object-fit:contain"
      ></video>
      <img
        ref="preview"
        v-bind:src="capturedImage"
        id="preview"
        v-if="hasCamera && configured && hasCapture"
        class="w-100 h-100"
        style="object-fit:contain"
      />
      <canvas ref="canvas" id="canvas"></canvas>
      <button
        class="btn btn-primary md switch-camera"
        v-if="hasMultiCamera"
        @click.stop="switchCamera()"
      >
        <i class="fa fa-exchange" style="color:#fff;padding-right:0"></i>
      </button>
      <button class="btn btn-primary md back" @click.stop="stop()">
        <i class="flaticon-reply" style="color:#fff;padding-right:0"></i>
      </button>
      <div class="buttons d-flex flex-row justify-content-between align-items-center px-2">
        <button class="btn btn-info md" @click.stop="capture()" v-if="!hasCapture">
          <i class="fa fa-camera-retro"></i>
          <span>{{$t('Take Photo')}}</span>
        </button>
        <button class="btn btn-primary md" @click.stop="recapture()" v-if="hasCapture">
          <i class="fa fa-arrow-left" style="color:#fff"></i>
          <span>{{$t('Take Another')}}</span>
        </button>
        <div class="text-center" style="flex:1" v-if="hasCapture">{{$t('Does It Look OK?')}}</div>
        <button class="btn btn-success md" @click.stop="looksgood()" :disabled="!hasCapture">
          <i class="fa fa-check-circle-o"></i>
          <span>{{$t('Looks Good')}}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { successConf, errorConf } from "@/shared/notifications";
import LanguageDropdown from "@/containers/LanguageDropdown";

const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;

export default {
  name: "imageUpload",
  components: {
    LanguageDropdown
  },
  data() {
    return {
      token: "",
      step: 1,

      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photo",
      formData: null,
      formFileList: [],

      video: {},
      canvas: {},
      hasCamera: false,
      hasMultiCamera: false,
      hasCapture: false,
      cameraMode: "environment",
      capturedImage:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=",
      configured: false,

      errMsg: "",
      isLoading: false
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  mounted() {
    this.token = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (!this.token) {
      this.$router.push("/");
    }
  },
  methods: {
    filesChange(ev) {
      const fieldName = ev.target.name;
      const fileList = ev.target.files;
      // handle file changes
      const formData = new FormData();
      const fl = [];

      if (!fileList.length) return;

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map(x => {
        // eslint-disable-line
        formData.append(fieldName, fileList[x], fileList[x].name);
        fl.push({ name: fileList[x].name, size: fileList[x].size });
      });
      this.formData = formData;
      this.formFileList = fl;
    },
    uploadImages() {
      let data = null;

      if (this.step == 2) {
        data = this.formData;
      } else {
        return;
      }

      const loader = this.$loading.open({
        container: this.$refs.body
      });

      this.$store
        .dispatch("imageUpload/upload", { data, id: this.token })
        .then(resp => {
          this.showSuccessNotification("Image uploaded");
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    switchTo(pag) {
      if (pag == 3) {
        this.init();
      }
      this.step = pag;
    },
    initializeCamera() {
      const self = this;

      // Older browsers might not implement mediaDevices at all, so we set an empty object first
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }

      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = constraints => {
          // First get ahold of the legacy getUserMedia, if present
          const getUserMedia =
            navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

          // Some browsers just don't implement it - return a rejected promise with an error
          // to keep a consistent interface
          if (!getUserMedia) {
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }

          // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
          return new Promise((resolve, reject) => {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }

      navigator.mediaDevices
        .getUserMedia({ video: { facingMode: self.cameraMode } })
        .then(stream => {
          self.stream = stream;

          // Older browsers may not have srcObject
          if ("srcObject" in self.video) {
            self.video.srcObject = stream;
          } else {
            // Avoid using this in new browsers, as it is going away.
            self.video.src = window.URL.createObjectURL(stream);
          }
          self.video.onloadedmetadata = () => {
            self.video.play();
            self.configured = true;
          };
        })
        .catch(err => {
          alert(`${err.name} : ${err.message} | ${err}`); // eslint-disable-line
          self.hasCamera = false;
          self.hasMultiCamera = false;
        });
    },
    init() {
      const self = this;
      if (
        typeof navigator.mediaDevices == "undefined" ||
        typeof navigator.mediaDevices.enumerateDevices == "undefined"
      ) {
        return;
      }
      navigator.mediaDevices.enumerateDevices().then(devices => {
        let count = 0;

        devices.forEach(device => {
          if (device.kind === "videoinput") {
            count += 1;
          }
        });
        if (count) {
          self.hasCamera = true;

          this.$nextTick(() => {
            self.video = self.$refs.video;
            self.canvas = self.$refs.canvas;
            self.initializeCamera();
          });

          if (count > 1) {
            self.hasMultiCamera = true;
          }
        }
      });
    },
    recapture() {
      this.hasCapture = false;
    },
    back() {
      this.step = 1;
    },
    stop() {
      this.cameraMode = "environment";
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
      }
      this.hasCapture = false;
      this.step = 1;
    },
    switchCamera() {
      if (this.cameraMode === "user") {
        this.cameraMode = "environment";
      } else {
        this.cameraMode = "user";
      }
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
      }
      this.initializeCamera();
    },
    capture() {
      this.canvas.height = this.video.videoHeight;
      this.canvas.width = this.video.videoWidth;
      this.canvas
        .getContext("2d")
        .drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
      this.capturedImage = this.canvas.toDataURL("image/jpeg");
      this.hasCapture = true;
    },
    looksgood() {
      if (this.step == 3 && this.hasCapture) {
        const data = {
          photo: this.capturedImage
        };

        this.$store
          .dispatch("imageUpload/upload", { data, id: this.token })
          .then(resp => {
            this.showSuccessNotification("Image uploaded");
          })
          .catch(err => {
            this.showErrorNotification(err);
          });
      }
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped>
.d-flex {
  position: relative;
}
#canvas {
  display: none;
}
.camera {
  color: #fff;
  position: relative;
  background-color: #000;

  .buttons {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .switch-camera {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  .back {
    position: absolute;
    top: 5px;
    left: 5px;
  }

  #preview {
    position: absolute;
  }
}
</style>
